(function(){
  "use strict";
  /* ====== CONFIGURE AQUI ====== */
  var MC_API   = "https://script.google.com/macros/s/AKfycbxVP14V5Z7Adf4xT4WZ3cdlCEtjX5qshZZf3keV7ttLuFudGzvoT7K_iHpIiep9fziu/exec";
  var MC_TOKEN = "mc_cc6f126b6aaf46bfa553068c22727813";
  var PAGE_DETALHE = "/pages/pedido";
  var PAGE_PRODUTO = "/pages/produto";
  var PER_PAGE = 20;
  var COLUMNS=[
    {k:"order_number",label:"ID",t:"id",on:true},
    {k:"created_at",label:"Data e hora",t:"dt",on:true},
    {k:"status",label:"Status",t:"status",on:true},
    {k:"customer_name",label:"Cliente",t:"text",on:true},
    {k:"itens_qtd",label:"Itens",t:"num",on:true},
    {k:"skus",label:"SKUs",t:"skus",on:true},
    {k:"subtotal",label:"Subtotal",t:"brl",on:false},
    {k:"desconto",label:"Desconto",t:"brl",on:false},
    {k:"cupom",label:"Cupom",t:"text",on:false},
    {k:"frete_real",label:"Valor frete",t:"fretereal",on:true},
    {k:"frete_cobrado",label:"Frete pago",t:"fretepago",on:true},
    {k:"taxa_gateway",label:"Taxa",t:"brl",on:false},
    {k:"faturamento",label:"Valor total",t:"brl",on:true},
    {k:"custo_total",label:"Custo",t:"brl",on:true},
    {k:"lucro",label:"Lucro",t:"brl",on:true},
    {k:"margem",label:"Margem",t:"pct",on:true},
    {k:"metodo_pagamento",label:"Pagamento",t:"text",on:false},
    {k:"metodo_envio",label:"Envio",t:"text",on:false},
    {k:"origem",label:"Origem",t:"text",on:false},
    {k:"campanha",label:"Campanha (conversão)",t:"text",on:false},
    {k:"campanha_sessao",label:"Campanha (sessão)",t:"text",on:false},
    {k:"anuncio",label:"Anúncio (conversão)",t:"anuncio",on:false},
    {k:"anuncio_sessao",label:"Anúncio (sessão)",t:"anuncio",on:false},
    {k:"ultimo_evento",label:"Estágio de Envio",t:"evento",on:true},
    {k:"tracking_number",label:"Rastreio",t:"tracking",on:true}
  ];
  var COLKEY={}; COLUMNS.forEach(function(c){COLKEY[c.k]=c;});
  var PINNED=["order_number","created_at","customer_name"]; // colunas fixas: ID, Data, Cliente
  /* v3: o bump força o default novo (coluna SKUs ligada) em quem já tinha seleção
     salva — loadState() acrescenta chave nova à ordem, mas não à seleção. */
  var STORE_KEY="mc_cols_pedidos_v3";
  /* ============================ */
  var root=document.getElementById("mc-root"),$=function(s){return root.querySelector(s);};
  function call(p){return new Promise(function(res,rej){var cb="mc_cb_"+Math.random().toString(36).slice(2),s=document.createElement("script"),to=setTimeout(function(){cl();rej(new Error("Tempo esgotado"));},20000);function cl(){clearTimeout(to);try{delete window[cb];}catch(e){window[cb]=undefined;}if(s.parentNode)s.parentNode.removeChild(s);}window[cb]=function(d){cl();res(d);};var qs=Object.keys(p).map(function(k){return encodeURIComponent(k)+"="+encodeURIComponent(p[k]);}).join("&");s.src=MC_API+"?key="+encodeURIComponent(MC_TOKEN)+"&callback="+cb+(qs?("&"+qs):"");s.onerror=function(){cl();rej(new Error("Falha de rede"));};document.head.appendChild(s);});}
  var BRL=function(n){return (Number(n)||0).toLocaleString("pt-BR",{style:"currency",currency:"BRL"});};
  var PCT=function(n){return ((Number(n)||0)*100).toFixed(1).replace(".",",")+"%";};
  var NUM=function(n){return (Number(n)||0).toLocaleString("pt-BR");};
  var DT=function(s){if(!s)return "-";var d=new Date(s);return isNaN(d)?"-":d.toLocaleDateString("pt-BR")+" "+d.toLocaleTimeString("pt-BR",{hour:"2-digit",minute:"2-digit"});};
  var esc=function(s){return String(s==null?"":s).replace(/[&<>"]/g,function(c){return({"&":"&amp;","<":"&lt;",">":"&gt;","\"":"&quot;"})[c];});};
  function statusClass(s){return "s-"+String(s||"").replace(/[^a-z]/gi,"").toLowerCase();}
  /* ── SKUs da expedição ──
     A coluna vem do backend como "SKU*qtd;SKU*qtd"; "?" marca peça que deveria ter
     SKU e não tem (kit ainda não resolvido na aba kit_map). Acessório sem SKU não
     entra na string — na expedição ele não vira etiqueta. */
  function parseSkus(v){
    return String(v||"").split(";").filter(Boolean).map(function(p){
      var i=p.lastIndexOf("*");
      return i<0?{sku:p,qtd:1}:{sku:p.slice(0,i),qtd:Number(p.slice(i+1))||1};
    });
  }
  /* cada chip copia SÓ o próprio SKU; o botão "tudo" copia o pedido inteiro.
     Um pedido de dez peças não obriga a colar as dez de uma vez. */
  function skusChips(v){
    var lista=parseSkus(v);
    var chips=lista.map(function(s){
      if(s.sku==="?") return '<span class="mc-sku-chip is-falta" title="Sem SKU confiável para esta peça — ou falta o SKU na variante da Shopify, ou é combo que não deu para resolver (aba kit_map). Nunca mostramos um SKU incerto aqui.">?'+(s.qtd>1?' ×'+s.qtd:'')+'</span>';
      return '<span class="mc-sku-chip" data-sku="'+esc(s.sku)+'" title="Clique para copiar este SKU">'+esc(s.sku)+(s.qtd>1?'<i>×'+s.qtd+'</i>':'')+'</span>';
    }).join("");
    if(lista.length>1) chips+='<button class="mc-sku-all" data-skus="'+esc(v)+'" title="Copiar os '+lista.length+' SKUs de uma vez">tudo</button>';
    return chips;
  }
  /* uma linha por PEÇA (repete o SKU na quantidade): é uma etiqueta por peça */
  function skusTexto(v){
    var out=[];
    parseSkus(v).forEach(function(s){ for(var i=0;i<s.qtd;i++) out.push(s.sku); });
    return out.join("\n");
  }
  /* mesmo tratamento de clique na tabela e no painel Etiquetas: chip copia um SKU,
     botão "tudo" copia o pedido. Devolve true quando tratou o clique. */
  function trataCliqueSku(ev){
    var chip=ev.target.closest(".mc-sku-chip");
    if(chip){
      ev.stopPropagation();
      var s=chip.getAttribute("data-sku");
      if(s) copiar(s,chip,"✓ "+s);       // is-falta não tem data-sku: nada a copiar
      return true;
    }
    var todos=ev.target.closest(".mc-sku-all");
    if(todos){
      ev.stopPropagation();
      copiar(skusTexto(todos.getAttribute("data-skus")),todos,"✓");
      return true;
    }
    return false;
  }
  function copiar(txt,el,label){
    if(!txt) return;
    function feito(){
      if(!el) return;
      if(el.getAttribute("data-old")===null||el.getAttribute("data-old")===undefined) el.setAttribute("data-old",el.innerHTML);
      el.innerHTML='<span class="mc-sku-ok">'+(label||"copiado ✓")+'</span>';
      setTimeout(function(){ var o=el.getAttribute("data-old"); if(o!=null){ el.innerHTML=o; el.removeAttribute("data-old"); } },1200);
    }
    function manual(){
      var ta=document.createElement("textarea"); ta.value=txt;
      ta.style.cssText="position:fixed;top:-9999px;left:-9999px";
      document.body.appendChild(ta); ta.select();
      try{ document.execCommand("copy"); feito(); }catch(e){}
      document.body.removeChild(ta);
    }
    if(navigator.clipboard&&navigator.clipboard.writeText) navigator.clipboard.writeText(txt).then(feito,manual);
    else manual();
  }
  function normalizeEvento(desc){
    var s=String(desc||'').toLowerCase().trim();
    if(!s||s==='-') return '';
    if(s.indexOf('entregue ao destinat')>=0) return 'Objeto entregue ao destinatário';
    if(s.indexOf('em transfer')>=0)          return 'Objeto em transferência';
    if(s==='dado recebido'||s==='documentacao completa'||s==='documentação completa') return 'Em produção';
    if(s==='entregue a transportadora local'||s==='enviado'||s==='processado'||s==='recebido'||s==='postado') return 'Postado';
    return desc;
  }
  var data=[], sortKey="created_at", sortDir=-1, page=1;
  var _overrides={}; // { order_id: {status, origem} } — overrides manuais, não sobrescritos pelo sync
  var _recovered={}; // { order_id: true } — pedidos que são conversão de carrinho abandonado
  var CART_SVG='<svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="vertical-align:-2px;margin-right:5px;color:var(--acc,#fff200)"><circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path></svg>';
  var st=loadState();
  var colOrder=st.order, selected=st.sel;
  function loadState(){
    try{ var s=JSON.parse(localStorage.getItem(STORE_KEY)); if(s&&s.order&&s.sel){ var ord=s.order.filter(function(k){return COLKEY[k];}); COLUMNS.forEach(function(c){ if(ord.indexOf(c.k)<0) ord.push(c.k); }); return {order:ord, sel:s.sel.filter(function(k){return COLKEY[k];})}; } }catch(e){}
    return { order: COLUMNS.map(function(c){return c.k;}), sel: COLUMNS.filter(function(c){return c.on;}).map(function(c){return c.k;}) };
  }
  function saveState(){ try{ localStorage.setItem(STORE_KEY, JSON.stringify({order:colOrder, sel:selected})); }catch(e){} }
  function activeCols(){
    // colunas fixas sempre primeiro (ID, Data, Cliente), depois as demais na ordem escolhida
    var rest=colOrder.filter(function(k){ return PINNED.indexOf(k)<0 && selected.indexOf(k)>=0; });
    return PINNED.concat(rest).map(function(k){return COLKEY[k];});
  }
  function getVal(o,k){ return o[k]; }
  function fmtCell(col,o){
    var v=o[col.k];
    if(col.t==="id") return '<td>#MNC'+esc(o.order_number)+'</td>';
    if(col.t==="dt") return '<td>'+DT(v)+'</td>';
    if(col.t==="status"){
      var ov=_overrides[String(o.id)];
      var sv=ov&&ov.status?ov.status:v;
      var isOv=!!(ov&&ov.status);
      return '<td><span class="mc-pill mc-ov-trigger '+statusClass(sv)+(isOv?" is-override":"")+'" data-ov-field="status" data-ov-id="'+esc(o.id)+'" data-ov-cur="'+esc(sv||"")+'">'+esc(sv||"-")+(isOv?'<span class="mc-ov-dot" title="Override manual"></span>':'')+'</span></td>';
    }
    if(col.k==="origem"){
      var orOv=_overrides[String(o.id)];
      var orV=(orOv&&orOv.origem)?orOv.origem:v;
      var orIsOv=!!(orOv&&orOv.origem);
      return '<td><span class="mc-ov-trigger'+(orIsOv?" is-override":"")+'" data-ov-field="origem" data-ov-id="'+esc(o.id)+'" data-ov-cur="'+esc(orV||"")+'">'+esc((orV===''||orV==null)?"-":orV)+(orIsOv?'<span class="mc-ov-dot" title="Override manual"></span>':'')+'</span></td>';
    }
    if(col.k==="metodo_pagamento"){
      var mc=String(v||'').toLowerCase();
      var isPix=mc.indexOf('pix')>=0, isCard=mc.indexOf('cartão')>=0||mc.indexOf('cartao')>=0||mc.indexOf('credit')>=0;
      var mcls=isPix?'mc-pay-pix':isCard?'mc-pay-card':'';
      var label=isPix?'Pix':isCard?'Cartão':(v||'');
      return '<td>'+(v?'<span class="mc-pay-chip '+mcls+'">'+esc(label)+'</span>':'-')+'</td>';
    }
    if(col.k==="customer_name"){
      var nm=(v===''||v==null)?"-":v;
      var rec=_recovered[String(o.id)]?'<span class="mc-cart-rec" title="Carrinho abandonado">'+CART_SVG+'</span>':'';
      return '<td>'+rec+esc(nm)+'</td>';
    }
    if(col.t==="text") return '<td>'+esc((v===''||v==null)?"-":v)+'</td>';
    if(col.k==="itens_qtd"){
      var n=Number(v)||0;
      return '<td><span class="mc-items-chip" data-tip="items" data-order-id="'+esc(o.id)+'">'+(n?(n===1?'1 item':n+' itens'):'-')+'</span></td>';
    }
    if(col.t==="skus"){
      var chips=skusChips(v);
      if(!chips) return '<td><span style="color:var(--mut)">—</span></td>';
      return '<td class="mc-sku-cell" data-skus="'+esc(v)+'">'+chips+'</td>';
    }
    if(col.t==="num") return '<td class="r">'+((v===''||v==null)?"-":NUM(v))+'</td>';
    if(col.t==="brl"){
      if(col.k==="lucro"){
        var lu=Number(v)||0;
        var cls=lu<0?"mc-neg":"mc-pos";
        var frGratis=(o.frete_gratis==="Sim");
        var fretePg=Number(o.frete_pago)||0;
        var tag=frGratis&&fretePg?'<span class="mc-frete-tag" data-tip="lucro" data-lucro="'+lu+'" data-frete="'+fretePg+'">FRETE</span>':'';
        return '<td class="r '+cls+'">'+BRL(lu)+tag+'</td>';
      }
      if(col.k==="custo_total"){
        var ct=Number(v)||0;
        var ctip='data-tip="custo" data-cogs="'+(Number(o.cogs)||0)+'" data-emb="'+(Number(o.embalagem)||0)+'" data-taxa="'+(Number(o.taxa_gateway)||0)+'" data-frete="'+(Number(o.frete_pago)||0)+'"';
        return '<td class="r" style="cursor:help" '+ctip+'>'+((v===''||v==null)?"-":BRL(ct))+'</td>';
      }
      if(col.k==="desconto"){
        var dv=Number(v)||0;
        if(!dv) return '<td class="r">-</td>';
        var dtip='data-tip="desconto" data-total="'+dv+'" data-cupom="'+esc(o.cupom||'')+'" data-sub="'+(Number(o.subtotal)||0)+'" data-fat="'+(Number(o.faturamento)||0)+'"';
        return '<td class="r" style="cursor:help" '+dtip+'>'+BRL(dv)+'</td>';
      }
      return '<td class="r">'+((v===''||v==null)?"-":BRL(v))+'</td>';
    }
    if(col.t==="fretereal"){
      // custo REAL do frete, puxado da Frenet (cotação/etiqueta) — nunca da Shopify/Yampi
      var frv=Number(v)||0;
      if(frv===0) return '<td class="r"><span style="color:#c3c3c3" title="Aguardando cotação Frenet">—</span></td>';
      var diff=frv-(Number(o.frete_cobrado)||0);
      return '<td class="r" style="cursor:help" data-tip="frete-diff" data-real="'+frv+'" data-pago="'+(Number(o.frete_cobrado)||0)+'" data-diff="'+diff.toFixed(2)+'">'+BRL(frv)+'</td>';
    }
    if(col.t==="fretepago"){
      // quanto o CLIENTE pagou de frete (Shopify)
      var fpv=Number(v)||0;
      if(fpv===0) return '<td class="r"><span style="color:'+(o.frete_gratis==="Sim"?"var(--warn,#f5a623)":"#c3c3c3")+'">'+(o.frete_gratis==="Sim"?"Grátis":"—")+'</span></td>';
      return '<td class="r">'+BRL(fpv)+'</td>';
    }
    if(col.t==="frete"){
      var fn=Number(v)||0;
      if(fn===0){
        var realFrete=Number(o.frete_pago)||0;
        if(realFrete){
          return '<td class="r"><span style="color:#c3c3c3">'+BRL(realFrete)+'</span></td>';
        }
        return '<td class="r"><span style="color:#c3c3c3">—</span></td>';
      }
      return '<td class="r">'+BRL(fn)+'</td>';
    }
    if(col.k==="cupom"){ return '<td>'+(v&&v!=='-'&&v!==''?'<span style="color:#bfbfbf">'+esc(v)+'</span>':'-')+'</td>'; }
    if(col.t==="pct") return '<td class="r '+((Number(v)||0)<0?"mc-neg":"")+'">'+PCT(v)+'</td>';
    if(col.t==="evento"){
      if(!v||String(v).trim()==='') return '<td><span style="color:var(--mut)">-</span></td>';
      var evNorm=normalizeEvento(String(v));
      var loc=String(o.local_evento||'');
      // só mostra local para status que fazem sentido com localização
      var showLoc=loc&&(evNorm.indexOf('transfer')>=0||evNorm.indexOf('entregue')>=0||evNorm.indexOf('Postado')>=0);
      return '<td><div class="mc-evt"><span class="mc-evt-val">'+esc(evNorm)+'</span>'+(showLoc?'<span class="mc-evt-label">'+esc(loc)+'</span>':'')+'</div></td>';
    }
    if(col.t==="tracking"){
      var tv=String(v||'').replace(/\s/g,'');
      var link=tv
        ?'<a class="mc-track-link" href="https://rastreio.frenet.com.br/COR/'+esc(tv.replace(/\s/g,''))+'" target="_blank" rel="noopener" onclick="event.stopPropagation()">'+esc(tv)+'</a>'
        :'<span style="color:var(--mut)">—</span>';
      return '<td style="white-space:nowrap">'+link+
        '<button class="mc-track-edit" data-id="'+esc(o.id)+'" data-track="'+esc(tv)+'" title="Editar rastreio">'+
          '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><path d="M11 2l3 3-8 8H3v-3L11 2z"/></svg>'+
        '</button></td>';
    }
    if(col.t==="anuncio"){
      var av=String(v||'').trim();
      if(!av) return '<td><span style="color:var(--mut)">—</span></td>';
      return '<td><span class="mc-anuncio-chip" data-tip="anuncio" data-anuncio="'+esc(av)+'" style="cursor:help">'+esc(av.length>28?av.slice(0,26)+'…':av)+'</span></td>';
    }
    return '<td></td>';
  }
  function buildHead(cols){
    root.querySelector(".mc-table thead tr").innerHTML=cols.map(function(col){
      var cls=(col.t==="brl"||col.t==="num"||col.t==="pct"||col.t==="frete"||col.t==="fretereal"||col.t==="fretepago")?"r":"";
      return '<th class="'+cls+'" data-s="'+col.k+'">'+esc(col.label)+'</th>';
    }).join("");
  }
  function rowsHtml(list,cols){
    if(!list.length) return '<tr><td colspan="'+Math.max(1,cols.length)+'" class="mc-empty">Nenhum pedido no periodo</td></tr>';
    return list.map(function(o){ var rowCls=o.status==='Não pago'?' class="row-naopago"':''; return '<tr'+rowCls+' data-id="'+esc(o.id)+'">'+cols.map(function(c){return fmtCell(c,o);}).join("")+'</tr>'; }).join("");
  }
  /* ── Ver pedidos Frenet: lista APENAS os envios criados direto na Frenet
        (que não existem na Shopify nem na Yampi) ── */
  var frenetFilterOn = false; // legado (filtro desativado — botão agora abre o modal)
  (function(){
    var fmodal=null;
    function ensureModal(){
      if(fmodal) return fmodal;
      fmodal=document.createElement("div");
      fmodal.id="mc-fo-modal";
      fmodal.style.cssText="display:none;position:fixed;inset:0;z-index:9998;align-items:center;justify-content:center";
      fmodal.innerHTML='<div id="mc-fo-bd" style="position:absolute;inset:0;background:rgba(0,0,0,.7)"></div>'
        +'<div style="position:relative;background:#0d0d0d;border:1px solid #2a2a2a;max-width:860px;width:92%;max-height:80vh;display:flex;flex-direction:column">'
        +'<div style="display:flex;justify-content:space-between;align-items:center;padding:14px 18px;border-bottom:1px solid #1e1e1e">'
        +'<b style="text-transform:uppercase;font-size:12px;letter-spacing:.06em">Pedidos criados na Frenet</b>'
        +'<button id="mc-fo-x" style="color:#8a8a8a;font-size:16px">&times;</button></div>'
        +'<div id="mc-fo-body" style="overflow:auto;padding:0 18px 18px"></div></div>';
      root.appendChild(fmodal);
      fmodal.querySelector("#mc-fo-x").addEventListener("click",function(){fmodal.style.display="none";});
      fmodal.querySelector("#mc-fo-bd").addEventListener("click",function(){fmodal.style.display="none";});
      return fmodal;
    }
    $("#mc-frenet-filter").addEventListener("click", function(){
      var m=ensureModal();
      m.style.display="flex";
      var body=m.querySelector("#mc-fo-body");
      body.innerHTML='<p class="mc-empty">Buscando envios na Frenet…</p>';
      call({resource:"frenet_orders"}).then(function(d){
        if(d&&d.error){ body.innerHTML='<p class="mc-empty" style="color:var(--bad,#ff4d4d)">'+esc(d.error)+'</p>'; return; }
        var rows=(d&&d.rows)||[];
        if(!rows.length){ body.innerHTML='<p class="mc-empty">Nenhum envio criado direto na Frenet (todos os envios vieram da Shopify/Yampi).</p>'; return; }
        body.innerHTML='<table style="width:100%;border-collapse:collapse;font-size:12px;margin-top:12px">'
          +'<thead><tr>'+['Pedido','Status','Serviço','Rastreio','Valor','Atualizado',''].map(function(h){return '<th style="text-align:left;text-transform:uppercase;font-size:10px;letter-spacing:.08em;color:#8a8a8a;padding:8px;border-bottom:1px solid #2a2a2a">'+h+'</th>';}).join('')+'</tr></thead><tbody>'
          +rows.map(function(r){
            return '<tr>'
              +'<td style="padding:8px;border-bottom:1px solid #1e1e1e">'+esc(r.order_id||r.shipment_id||'—')+'</td>'
              +'<td style="padding:8px;border-bottom:1px solid #1e1e1e">'+esc(r.status||'—')+'</td>'
              +'<td style="padding:8px;border-bottom:1px solid #1e1e1e">'+esc((r.transportadora?r.transportadora+' · ':'')+(r.servico||'—'))+'</td>'
              +'<td style="padding:8px;border-bottom:1px solid #1e1e1e">'+(r.rastreio?'<a class="mc-track-link" href="'+esc(r.tracking_url||('https://rastreio.frenet.com.br/COR/'+r.rastreio))+'" target="_blank" rel="noopener">'+esc(r.rastreio)+'</a>':'—')+'</td>'
              +'<td style="padding:8px;border-bottom:1px solid #1e1e1e">'+(r.valor?BRL(r.valor):'—')+'</td>'
              +'<td style="padding:8px;border-bottom:1px solid #1e1e1e;color:#8a8a8a">'+(r.atualizado?DT(r.atualizado):'—')+'</td>'
              +'<td style="padding:8px;border-bottom:1px solid #1e1e1e">'+(r.label_url?'<a class="mc-track-link" href="'+esc(r.label_url)+'" target="_blank" rel="noopener">etiqueta</a>':'')+'</td>'
              +'</tr>';
          }).join('')+'</tbody></table>'
          +'<p style="color:#8a8a8a;font-size:10px;margin-top:10px;text-transform:uppercase;letter-spacing:.04em">'+rows.length+' envio'+(rows.length>1?'s':'')+' apenas na Frenet</p>';
      }).catch(function(e){ body.innerHTML='<p class="mc-empty" style="color:var(--bad,#ff4d4d)">Erro: '+esc(e.message)+'</p>'; });
    });
  })();

  /* ── Painel Etiquetas: percorrer os pedidos um a um, copiando os SKUs ──
        Não chama o backend: usa o mesmo array já carregado, filtrado por currentView(),
        então respeita período, status e busca ativos na página. */
  (function(){
    var DONE_KEY="mc_etq_done", MAX_DIAS=30, emodal=null;
    /* o que já foi conferido mora no navegador e sobrevive ao auto-refresh de 60s e a
       fechar o painel — é o que sustenta o fluxo pedido a pedido. Entradas velhas
       saem sozinhas para a chave não crescer sem fim. */
    function loadDone(){
      try{
        var d=JSON.parse(localStorage.getItem(DONE_KEY))||{}, corte=Date.now()-MAX_DIAS*864e5, out={};
        Object.keys(d).forEach(function(k){ if(Number(d[k])>corte) out[k]=d[k]; });
        return out;
      }catch(e){ return {}; }
    }
    function saveDone(d){ try{ localStorage.setItem(DONE_KEY,JSON.stringify(d)); }catch(e){} }
    var done=loadDone();

    function ensureModal(){
      if(emodal) return emodal;
      emodal=document.createElement("div");
      emodal.id="mc-etq";
      emodal.style.cssText="display:none;position:fixed;inset:0;z-index:9998;align-items:center;justify-content:center";
      emodal.innerHTML='<div id="mc-etq-bd" style="position:absolute;inset:0;background:rgba(0,0,0,.75)"></div>'
        +'<div style="position:relative;background:#0d0d0d;border:1px solid #2a2a2a;max-width:720px;width:94%;max-height:84vh;display:flex;flex-direction:column">'
        +'<div style="display:flex;justify-content:space-between;align-items:center;padding:14px 18px;border-bottom:1px solid #1e1e1e">'
        +'<b style="text-transform:uppercase;font-size:12px;letter-spacing:.06em">Etiquetas — SKUs por pedido</b>'
        +'<button id="mc-etq-x" style="color:#8a8a8a;font-size:16px">&times;</button></div>'
        +'<div id="mc-etq-body" style="overflow:auto;padding:0 18px"></div>'
        +'<div class="etq-foot"><span id="mc-etq-cont"></span><button class="etq-reset" id="mc-etq-reset">Limpar conferidos</button></div>'
        +'</div>';
      root.appendChild(emodal);
      emodal.querySelector("#mc-etq-x").addEventListener("click",fechar);
      emodal.querySelector("#mc-etq-bd").addEventListener("click",fechar);
      emodal.querySelector("#mc-etq-reset").addEventListener("click",function(){ done={}; saveDone(done); abrir(); });
      emodal.querySelector("#mc-etq-body").addEventListener("click",function(ev){
        if(trataCliqueSku(ev)) return;   // chip copia um SKU só, igual à tabela
        var cp=ev.target.closest(".etq-copy");
        if(cp){ copiar(skusTexto(cp.getAttribute("data-skus")),cp,"copiado ✓"); return; }
        var chk=ev.target.closest(".etq-chk");
        if(chk){
          var linha=chk.closest(".etq-row"), oid=linha.getAttribute("data-id");
          /* não reordena aqui: mover a linha embaixo do cursor faria perder o lugar */
          if(chk.checked){ done[oid]=Date.now(); linha.classList.add("is-done"); }
          else { delete done[oid]; linha.classList.remove("is-done"); }
          saveDone(done); contar();
        }
      });
      return emodal;
    }
    function fechar(){ if(emodal) emodal.style.display="none"; }
    function contar(){
      if(!emodal) return;
      var linhas=emodal.querySelectorAll(".etq-row"), feitos=emodal.querySelectorAll(".etq-row.is-done");
      emodal.querySelector("#mc-etq-cont").textContent=linhas.length?(feitos.length+" de "+linhas.length+" conferidos"):"";
    }
    function abrir(){
      var m=ensureModal(); m.style.display="flex";
      var body=m.querySelector("#mc-etq-body");
      /* só pedidos com peça a etiquetar; não conferidos primeiro, mais antigos no topo */
      var lista=currentView().filter(function(o){ return String(o.skus||"").length>0; }).sort(function(a,b){
        var da=!!done[String(a.id)], db=!!done[String(b.id)];
        if(da!==db) return da?1:-1;
        return new Date(a.created_at||0)-new Date(b.created_at||0);
      });
      if(!lista.length){
        body.innerHTML='<p class="mc-empty">Nenhum pedido com SKU no filtro atual. O painel segue o período, o status e a busca da página.</p>';
        contar(); return;
      }
      body.innerHTML=lista.map(function(o){
        var fin=!!done[String(o.id)];
        return '<div class="etq-row'+(fin?" is-done":"")+'" data-id="'+esc(o.id)+'">'
          +'<input type="checkbox" class="etq-chk"'+(fin?" checked":"")+' title="Marcar como conferido">'
          +'<div class="etq-mid">'
            +'<div class="etq-id">#MNC'+esc(o.order_number)+'<span class="etq-cli">'+esc(o.customer_name||"—")+'</span></div>'
            +'<div class="etq-skus">'+skusChips(o.skus)+'</div>'
          +'</div>'
          +'<button class="etq-copy" data-skus="'+esc(o.skus)+'">copiar</button>'
        +'</div>';
      }).join("");
      contar();
    }
    $("#mc-etq-btn").addEventListener("click",abrir);
    document.addEventListener("keydown",function(e){ if(e.key==="Escape") fechar(); });
  })();

  /* ── verifica saldo Frenet (assíncrono, sem bloquear) ── */
  (function checkFrenetBalance(){
    call({resource:"frenet_balance"}).then(function(r){
      if(r && r.ok && r.balance < 50){
        var el = document.getElementById("mc-frenet-alert");
        el.textContent = "⚠ Saldo Frenet baixo: R$ "+Number(r.balance).toLocaleString("pt-BR",{minimumFractionDigits:2,maximumFractionDigits:2})+" — recarregue antes de gerar mais etiquetas";
        el.style.display = "block";
      }
    }).catch(function(){});
  })();

  function currentView(){
    var q=($("#mc-search").value||"").toLowerCase().trim(), stf=$("#mc-status").value.toLowerCase();
    var view=data.filter(function(o){
      if(stf && String(o.status||"").toLowerCase()!==stf) return false;
      if(q){var hay=(o.order_number+" "+o.customer_name+" "+o.status+" "+o.origem+" "+o.metodo_pagamento+" "+(o.skus||"")).toLowerCase(); if(hay.indexOf(q)<0) return false;}
      // filtro Frenet: sem tracking e sem label comprada (precisa de etiqueta)
      if(frenetFilterOn){
        var hasTrack = String(o.tracking_number||'').trim().length > 0;
        var hasLabel = String(o.label_comprada||'').trim().length > 0;
        if(hasTrack || hasLabel) return false;
      }
      return true;
    });
    var col=COLKEY[sortKey]; var numeric=col&&(col.t==="num"||col.t==="brl"||col.t==="pct"||col.t==="frete"||col.t==="fretereal"||col.t==="fretepago"||col.t==="id");
    view.sort(function(a,b){var x,y;
      if(sortKey==="created_at"){x=new Date(a.created_at||0);y=new Date(b.created_at||0);}
      else{ x=getVal(a,sortKey); y=getVal(b,sortKey); if(numeric){x=Number(x)||0;y=Number(y)||0;} else {x=String(x||"").toLowerCase();y=String(y||"").toLowerCase();} }
      return x<y?-1*sortDir:x>y?sortDir:0;});
    return view;
  }
  function renderPag(totalPages){
    var c=$("#mc-pages"); c.innerHTML=""; if(totalPages<=1) return;
    function btn(label,p,dis,act){var b=document.createElement("button");b.textContent=label;if(dis)b.disabled=true;if(act)b.classList.add("is-active");if(!dis&&!act)b.addEventListener("click",function(){page=p;render();});c.appendChild(b);}
    btn("< Ant",page-1,page===1,false); for(var i=1;i<=totalPages;i++) btn(String(i),i,false,i===page); btn("Prox >",page+1,page===totalPages,false);
  }
  function updateSort(){
    Array.prototype.forEach.call(root.querySelectorAll(".mc-table thead th[data-s]"),function(th){
      if(!th.dataset.label) th.dataset.label=th.textContent;
      var active=th.getAttribute("data-s")===sortKey;
      th.textContent=th.dataset.label+(active?(sortDir===1?" ▲":" ▼"):"");
      th.style.color=active?"#d7d7d7":"";
    });
  }
  function applyPins(){
    // offsets das 3 colunas fixas (ID, Data, Cliente)
    var ths=root.querySelectorAll(".mc-table thead th");
    if(ths.length<3) return;
    var l1=ths[0].offsetWidth, l2=l1+ths[1].offsetWidth;
    root.style.setProperty("--pinl1", l1+"px");
    root.style.setProperty("--pinl2", l2+"px");
  }
  function render(){
    var cols=activeCols(); buildHead(cols);
    var view=currentView();
    var totalPages=Math.max(1,Math.ceil(view.length/PER_PAGE)); if(page>totalPages)page=totalPages;
    var slice=view.slice((page-1)*PER_PAGE,page*PER_PAGE);
    $("#mc-rows").innerHTML=rowsHtml(slice,cols);
    $("#mc-count").textContent=view.length+" pedidos - clique pra abrir";
    renderPag(totalPages); updateSort(); applyPins();
  }
  var curRange="30d";
  function load(range){
    curRange=range;
    page=1; $("#mc-err").hidden=true; $("#mc-pages").innerHTML="";
    var lsKey='mc_p_orders_'+range;
    // Stale-while-revalidate: mostra cache instantaneamente, atualiza em background
    var stale=null;
    try{ var s=localStorage.getItem(lsKey); if(s){ stale=JSON.parse(s); } }catch(e){}
    if(stale&&stale.rows){
      data=stale.rows; render();
      $("#mc-count").textContent=data.length+" pedidos - atualizando…";
    } else {
      $("#mc-rows").innerHTML='<tr><td class="mc-empty">Carregando...</td></tr>';
    }
    call({resource:"orders",range:range}).then(function(d){
      if(d&&d.error){ if(!stale) fail(d.error); return; }
      data=(d&&d.rows)||[];
      try{ localStorage.setItem(lsKey,JSON.stringify({ts:Date.now(),rows:data})); }catch(e){}
      render();
    }).catch(function(e){ if(!stale) fail(e.message); });
    // conjunto de pedidos que são conversão de carrinho abandonado (para o ícone)
    call({resource:"recovered_orders"}).then(function(d){
      if(d&&d.order_ids){ _recovered={}; d.order_ids.forEach(function(id){ _recovered[String(id)]=true; }); render(); }
    }).catch(function(){});
  }
  function fail(m){var e=$("#mc-err");e.hidden=false;e.textContent="Erro ao carregar: "+m+(m==="unauthorized"?" - confira o token.":"");}
  /* ---- seletor de colunas com reordenar (arrastar) ---- */
  function buildPicker(){
    var h='<div class="mc-colpick-hint">ID, Data e Cliente são fixas · arraste pra reordenar</div>';
    h+=colOrder.filter(function(k){ return PINNED.indexOf(k)<0; }).map(function(k){ var c=COLKEY[k]; return '<div class="cpi" draggable="true" data-k="'+k+'"><span class="grip">⠿</span><label><input type="checkbox" value="'+k+'"'+(selected.indexOf(k)>=0?' checked':'')+'>'+esc(c.label)+'</label></div>'; }).join("");
    $("#mc-colpick-panel").innerHTML=h;
  }
  var dragK=null;
  $("#mc-colpick-btn").addEventListener("click",function(){ $("#mc-colpick").classList.toggle("open"); });
  var panel=$("#mc-colpick-panel");
  panel.addEventListener("change",function(ev){ var cb=ev.target; if(!cb||cb.type!=="checkbox")return; if(cb.checked){ if(selected.indexOf(cb.value)<0) selected.push(cb.value); } else { selected=selected.filter(function(k){return k!==cb.value;}); } saveState(); render(); });
  panel.addEventListener("dragstart",function(ev){ var it=ev.target.closest(".cpi"); if(it){ dragK=it.getAttribute("data-k"); it.classList.add("drag"); } });
  panel.addEventListener("dragend",function(ev){ var it=ev.target.closest(".cpi"); if(it)it.classList.remove("drag"); dragK=null; });
  panel.addEventListener("dragover",function(ev){ ev.preventDefault(); });
  panel.addEventListener("drop",function(ev){ ev.preventDefault(); var it=ev.target.closest(".cpi"); if(!it||!dragK)return; var overK=it.getAttribute("data-k"); if(overK===dragK)return; var from=colOrder.indexOf(dragK),to=colOrder.indexOf(overK); if(from<0||to<0)return; colOrder.splice(from,1); colOrder.splice(to,0,dragK); saveState(); buildPicker(); render(); });
  /* ---- clique / ordenacao / filtros ---- */
  $("#mc-rows").addEventListener("click",function(ev){
    /* copiar SKU não pode abrir o pedido: o tratador intercepta antes */
    if(trataCliqueSku(ev)) return;
    if(ev.target.closest(".mc-sku-cell")) return;   // espaço vazio da célula: não navega
    if(ev.target.closest("a"))return;if(ev.target.closest(".mc-track-edit"))return;if(ev.target.closest(".mc-ov-trigger"))return;var tr=ev.target.closest("tr[data-id]");if(tr)window.location.href=PAGE_DETALHE+"?id="+encodeURIComponent(tr.getAttribute("data-id"));});
  root.querySelector(".mc-table thead").addEventListener("click",function(ev){var th=ev.target.closest("th[data-s]");if(!th)return;var k=th.getAttribute("data-s");var col=COLKEY[k];var numeric=col&&(col.t==="num"||col.t==="brl"||col.t==="pct"||col.t==="frete"||col.t==="id"||col.t==="dt");if(k===sortKey)sortDir*=-1;else{sortKey=k;sortDir=numeric?-1:1;}page=1;render();});
  $("#mc-search").addEventListener("input",function(){page=1;render();});
  $("#mc-status").addEventListener("change",function(){page=1;render();});
  $("#mc-perpage").addEventListener("change",function(){ PER_PAGE=Number(this.value)||20; page=1; render(); });
  /* ---- seletor de periodo ---- */
  var fpInstance=null;
  try { if(typeof flatpickr!=="undefined"){ fpInstance=flatpickr("#mc-date-range",{mode:"range",locale:"pt",dateFormat:"Y-m-d",altInput:true,altFormat:"d/m/Y"}); } } catch(e){ fpInstance=null; }
  function setActiveOpt(el){ Array.prototype.forEach.call($("#mc-range-opts").querySelectorAll("button"),function(x){x.classList.remove("is-active");}); if(el) el.classList.add("is-active"); }
  $("#mc-range-toggle").addEventListener("click",function(){ var rp=$("#mc-rangepicker"); var open=rp.classList.toggle("open"); this.setAttribute("aria-expanded",open?"true":"false"); });
  $("#mc-range-opts").addEventListener("click",function(ev){
    var custom=ev.target.closest("#mc-btn-custom"); var b=ev.target.closest("button[data-range]"); var picker=$("#mc-custom-date-picker");
    if(custom){ setActiveOpt(custom); $("#mc-range-label").textContent="Personalizado"; picker.style.display=fpInstance?"flex":"none"; if(!fpInstance) alert("Calendario nao carregou."); return; }
    if(!b) return; picker.style.display="none"; setActiveOpt(b); $("#mc-range-label").textContent=b.textContent; $("#mc-rangepicker").classList.remove("open"); load(b.getAttribute("data-range"));
  });
  $("#mc-btn-apply-dates").addEventListener("click",function(){
    if(!fpInstance || fpInstance.selectedDates.length<2){ alert("Selecione o dia inicial e o final."); return; }
    var s=fpInstance.formatDate(fpInstance.selectedDates[0],"Y-m-d"),e=fpInstance.formatDate(fpInstance.selectedDates[1],"Y-m-d");
    $("#mc-range-label").textContent=fpInstance.formatDate(fpInstance.selectedDates[0],"d/m")+"-"+fpInstance.formatDate(fpInstance.selectedDates[1],"d/m");
    $("#mc-rangepicker").classList.remove("open"); load(s+"~"+e);
  });
  document.addEventListener("click",function(ev){ var rp=$("#mc-rangepicker"); if(rp&&!rp.contains(ev.target)) rp.classList.remove("open"); var cp=$("#mc-colpick"); if(cp&&!cp.contains(ev.target)) cp.classList.remove("open"); });
  /* ---- tooltip de custo e frete ---- */
  (function(){
    var tip=document.createElement("div"); tip.className="mc-ptip"; root.appendChild(tip);
    var _itemsCache={}, _tipEl=null, _tipMx=0, _tipMy=0, _hideT=null, _interactive=false;
    function row(l,v,cls){ return '<div class="pt-row'+(cls?' '+cls:'')+'"><span>'+l+'</span><b>'+v+'</b></div>'; }
    function showTip(el,mx,my){ _tipEl=el; _tipMx=mx; _tipMy=my;
      var t=el.getAttribute("data-tip");
      var h='';
      if(t==="lucro"){
        var lu=Number(el.getAttribute("data-lucro"))||0;
        var fr=Number(el.getAttribute("data-frete"))||0;
        h+=row("Lucro s/ frete",BRL(lu+fr));
        h+='<div class="pt-sep"></div>';
        h+=row("Frete absorvido",BRL(fr),"pt-hl");
        h+=row("Lucro líquido",BRL(lu),lu<0?"":"pt-hl");
      } else if(t==="custo"){
        var cogs=Number(el.getAttribute("data-cogs"))||0;
        var emb=Number(el.getAttribute("data-emb"))||0;
        var taxa=Number(el.getAttribute("data-taxa"))||0;
        var frete=Number(el.getAttribute("data-frete"))||0;
        h+=row("Produto (COGS)",BRL(cogs));
        h+=row("Embalagem",BRL(emb));
        h+=row("Taxa gateway",BRL(taxa));
        if(frete>0) h+=row("Frete absorvido",BRL(frete),"pt-hl");
        h+='<div class="pt-sep"></div>';
        h+=row("Total",BRL(cogs+emb+taxa+frete));
      } else if(t==="desconto"){
        var dtotal=Number(el.getAttribute("data-total"))||0;
        var dcupom=el.getAttribute("data-cupom")||'';
        var dsub=Number(el.getAttribute("data-sub"))||0;
        var dfat=Number(el.getAttribute("data-fat"))||0;
        h+=row("Subtotal",BRL(dsub));
        h+=row("Desconto total",BRL(dtotal));
        if(dcupom) h+=row("Cupom",esc(dcupom));
        h+='<div class="pt-sep"></div>';
        h+=row("Total cobrado",BRL(dfat));
      } else if(t==="frete-real"){
        var rv=Number(el.getAttribute("data-val"))||0;
        h+=row("Custo real do frete",BRL(rv),"pt-hl");
        h+='<div class="pt-sep"></div>';
        h+='<div style="font-size:10px;color:var(--mut)">Absorvido pela loja</div>';
      } else if(t==="frete-diff"){
        var fdReal=Number(el.getAttribute("data-real"))||0;
        var fdPago=Number(el.getAttribute("data-pago"))||0;
        var fdDiff=Number(el.getAttribute("data-diff"))||0;
        h+=row("Custo real (Frenet)",BRL(fdReal));
        h+=row("Pago pelo cliente",BRL(fdPago));
        h+='<div class="pt-sep"></div>';
        h+=row(fdDiff>=0?"Absorvido pela loja":"Excedente do cliente",BRL(Math.abs(fdDiff)),"pt-hl");
        h+='<div style="font-size:10px;color:var(--mut)">A diferença entra nas contas de custo</div>';
      } else if(t==="anuncio"){
        var name=el.getAttribute("data-anuncio")||'';
        h+='<div style="padding:4px 0;max-width:260px;word-break:break-word;color:#c8c8c8">'+esc(name)+'</div>';
        // Se parece um ad_id numérico, tenta thumbnail via GAS
        if(/^\d{10,}$/.test(name)){
          if(_itemsCache['ad_'+name]){
            var tu=_itemsCache['ad_'+name];
            h='<img src="'+tu+'" style="width:200px;height:auto;display:block;border-radius:3px" onerror="this.style.display=none">'+'<div style="padding:4px 0;font-size:10px;color:var(--mut)">'+esc(name)+'</div>';
          } else if(_itemsCache['ad_'+name]===null){
            h='<div style="color:var(--mut);padding:4px 0">Carregando…</div>';
          } else {
            _itemsCache['ad_'+name]=null;
            h='<div style="color:#c8c8c8;padding:4px 0">'+esc(name)+'</div><div style="color:var(--mut);font-size:10px">Carregando mídia…</div>';
            call({resource:'ad_thumb',ad_id:name}).then(function(d){
              _itemsCache['ad_'+name]=d&&d.thumbnail_url?d.thumbnail_url:'';
              if(_tipEl&&_tipEl.getAttribute("data-anuncio")===name&&tip.style.display!=="none") showTip(_tipEl,_tipMx,_tipMy);
            }).catch(function(){_itemsCache['ad_'+name]='';});
          }
        }
      } else if(t==="items"){
        var oid=el.getAttribute("data-order-id");
        if(_itemsCache[oid] && _itemsCache[oid].length){
          var its=_itemsCache[oid];
          h+=its.map(function(it){
            /* nome_exibicao/link_id só existem depois do deploy novo do Apps Script;
               sem eles cai no comportamento antigo (texto puro, sem link). */
            var nome=esc(it.nome_exibicao||it.title||it.sku||"—");
            var det=[];
            if(it.is_kit){ if(it.tamanho) det.push(esc(it.tamanho)); if(it.title) det.push("via "+esc(it.title)); }
            else if(it.variant_title&&it.variant_title!=="-") det.push(esc(it.variant_title));
            var lbl=nome+(det.length?' <span class="pt-sub">'+det.join(" · ")+'</span>':'');
            var lid=it.link_id||"";
            return row(lid?('<a class="pt-link" href="'+PAGE_PRODUTO+'?id='+encodeURIComponent(lid)+'">'+lbl+'</a>'):lbl,
                       (it.quantity||1)+" × "+BRL(it.price||0));
          }).join("");
        } else if(_itemsCache[oid]===null){
          h+='<div style="color:var(--mut);padding:4px 0">Carregando…</div>';
        } else {
          _itemsCache[oid]=null;
          h+='<div style="color:var(--mut);padding:4px 0">Carregando…</div>';
          call({resource:"order",id:oid}).then(function(d){
            _itemsCache[oid]=(d&&d.items)||[];
            if(_tipEl&&_tipEl.getAttribute("data-order-id")===oid&&tip.style.display!=="none")
              showTip(_tipEl,_tipMx,_tipMy);
          }).catch(function(){_itemsCache[oid]=[];});
        }
      }
      if(!h) return;
      tip.innerHTML=h;
      /* o tooltip de itens tem links: precisa receber clique e parar de correr
         atrás do mouse, senão é impossível alcançá-lo. Os demais seguem
         decorativos (pointer-events:none) e continuam acompanhando o cursor. */
      var interativo = (t==="items");
      tip.classList.toggle("is-interactive", interativo);
      var jaAberto = (_interactive && interativo && tip.style.display==="block");
      _interactive = interativo;
      tip.style.display="block";
      if(jaAberto) return;   // mantém a posição travada enquanto dá para clicar
      var x=mx+14, y=my-tip.offsetHeight/2;
      if(x+tip.offsetWidth>window.innerWidth) x=mx-tip.offsetWidth-10;
      if(y<4) y=4; if(y+tip.offsetHeight>window.innerHeight) y=window.innerHeight-tip.offsetHeight-4;
      tip.style.left=x+"px"; tip.style.top=y+"px";
    }
    function hideTip(){ clearTimeout(_hideT); tip.style.display="none"; tip.classList.remove("is-interactive"); _tipEl=null; _interactive=false; }
    /* atraso para o mouse conseguir atravessar o vão até o tooltip */
    function hideSoon(){ clearTimeout(_hideT); _hideT=setTimeout(hideTip, _interactive?220:0); }
    tip.addEventListener("mouseenter",function(){ clearTimeout(_hideT); });
    tip.addEventListener("mouseleave",hideTip);
    root.addEventListener("mouseover",function(ev){
      var el=ev.target.closest("[data-tip]");
      if(el){ clearTimeout(_hideT); showTip(el,ev.clientX,ev.clientY); }
    });
    root.addEventListener("mousemove",function(ev){
      if(tip.style.display==="none") return;
      var el=ev.target.closest("[data-tip]");
      if(el){ clearTimeout(_hideT); showTip(el,ev.clientX,ev.clientY); }
      else if(!tip.contains(ev.target)) hideSoon();
    });
    root.addEventListener("mouseout",function(ev){
      if(!ev.target.closest("[data-tip]")) hideSoon();
    });
  })();
  buildPicker();
  load("30d");
  // Auto-refresh silencioso: rebusca os pedidos a cada 60s mantendo página/filtros/ordenacão
  setInterval(function(){
    if(document.hidden) return;
    call({resource:"orders",range:curRange}).then(function(d){
      if(d&&d.rows){
        data=d.rows;
        try{ localStorage.setItem('mc_p_orders_'+curRange,JSON.stringify({ts:Date.now(),rows:data})); }catch(e){}
        render();
      }
    }).catch(function(){});
  },60000);

  /* ─── modal de rastreio ─── */
  (function(){
    var modal=document.getElementById("mc-track-modal");
    var inp=document.getElementById("tm-inp");
    var msgEl=document.getElementById("tm-msg");
    var saveBtn=document.getElementById("tm-save");
    var currentOrderId="";

    function stripSpaces(v){ return String(v||"").replace(/\s/g,""); }
    inp.addEventListener("input",function(){ var p=inp.selectionStart; inp.value=stripSpaces(inp.value); inp.setSelectionRange(p,p); });
    inp.addEventListener("paste",function(e){ e.preventDefault(); var t=stripSpaces((e.clipboardData||window.clipboardData).getData("text")); document.execCommand("insertText",false,t); });

    function openTrack(orderId, currentTracking){
      currentOrderId=orderId;
      inp.value=stripSpaces(currentTracking);
      document.getElementById("tm-notify").checked=true;
      document.getElementById("tm-title").textContent="Rastreio — Pedido #MNC"+orderId;
      msgEl.style.display="none"; msgEl.className="tm-msg";
      saveBtn.disabled=false; saveBtn.textContent="Salvar e atualizar";
      modal.style.display="flex";
      setTimeout(function(){ inp.focus(); inp.select(); },60);
    }
    function closeTrack(){ modal.style.display="none"; currentOrderId=""; }

    // abrir via clique no ícone de lápis
    document.getElementById("mc-root").addEventListener("click",function(ev){
      var btn=ev.target.closest(".mc-track-edit");
      if(!btn) return;
      ev.stopPropagation();
      openTrack(btn.dataset.id, btn.dataset.track);
    });

    document.getElementById("tm-close").addEventListener("click",closeTrack);
    document.getElementById("tm-cancel").addEventListener("click",closeTrack);
    document.getElementById("tm-bd").addEventListener("click",closeTrack);
    document.addEventListener("keydown",function(e){
      if(e.key==="Escape"&&modal.style.display!=="none") closeTrack();
      if(e.key==="Enter"&&modal.style.display!=="none") saveBtn.click();
    });

    saveBtn.addEventListener("click",function(){
      var tracking=stripSpaces(inp.value);
      if(!tracking){ inp.focus(); return; }
      if(!currentOrderId) return;
      var notify=document.getElementById("tm-notify").checked;
      saveBtn.disabled=true; saveBtn.textContent="Salvando…";
      msgEl.style.display="none";

      // chama GAS via JSONP
      var cb="mc_trk_"+Math.random().toString(36).slice(2);
      var s=document.createElement("script");
      var to=setTimeout(function(){ cleanup(); showMsg("Tempo esgotado.",false); },25000);
      function cleanup(){ clearTimeout(to); try{delete window[cb];}catch(e){} if(s.parentNode) s.parentNode.removeChild(s); }

      window[cb]=function(d){
        cleanup();
        if(d&&d.ok){
          showMsg("Rastreio atualizado"+(notify?" · cliente notificado":"")+".",true);
          saveBtn.textContent="Salvo ✓";
          // atualiza célula na tabela sem recarregar
          var cells=document.querySelectorAll(".mc-track-edit[data-id='"+currentOrderId+"']");
          cells.forEach(function(btn){
            btn.dataset.track=tracking;
            var td=btn.closest("td");
            if(td){
              var a=td.querySelector(".mc-track-link");
              if(a){ a.textContent=tracking; a.href="https://rastreio.frenet.com.br/COR/"+tracking.replace(/\s/g,''); }
              else { td.innerHTML='<a class="mc-track-link" href="https://rastreio.frenet.com.br/COR/'+tracking.replace(/\s/g,'')+'" target="_blank" rel="noopener" onclick="event.stopPropagation()">'+tracking+'</a>'+td.innerHTML.match(/<button[\s\S]*$/)||''; }
            }
          });
          // atualiza data em memória
          data.forEach(function(o){ if(String(o.id)===String(currentOrderId)) o.tracking_number=tracking; });
          setTimeout(closeTrack, 1800);
        } else {
     
          showMsg("Erro: "+(d&&d.error?d.error:"Falha desconhecida."),false);
          saveBtn.disabled=false; saveBtn.textContent="Tentar novamente";
        }
      };

      var MC_API_T="https://script.google.com/macros/s/AKfycbwp5p1QWOI0hJbELCrsykEOSQa3bBiZZ5ptpE_SwZWaReHGO419IRUrA1pVStKHz98/exec";
      var MC_TOKEN_T="mc_cc6f126b6aaf46bfa553068c22727813";
      s.src=MC_API_T+"?key="+encodeURIComponent(MC_TOKEN_T)+"&callback="+cb+
        "&resource=update_tracking"+
        "&order_id="+encodeURIComponent(currentOrderId)+
        "&tracking="+encodeURIComponent(tracking)+
        "&notify="+(notify?"true":"false");
      s.onerror=function(){ cleanup(); showMsg("Falha de rede.",false); saveBtn.disabled=false; saveBtn.textContent="Tentar novamente"; };
      document.head.appendChild(s);
    });

    function showMsg(txt,ok){
      msgEl.textContent=txt;
      msgEl.className="tm-msg "+(ok?"ok":"err");
      msgEl.style.display="block";
    }
  })();

  /* ─────────── Override manual de status / origem ─────────── */
  var STATUS_OPTS=["Pago","Não pago","Cancelado","Em análise","Aguardando","Em produção","Em transporte","Entregue","Devolvido","Reembolsado","Troca"];
  var ORIGEM_OPTS=["Tráfego pago","Orgânico","Email","WhatsApp","Direto","Indicação","Marketplace","Loja física"];

  function loadOverrides(){
    call({resource:"order_overrides_list"}).then(function(d){
      _overrides={};
      ((d&&d.rows)||[]).forEach(function(r){ if(r.order_id) _overrides[String(r.order_id)]=r; });
      render();
    }).catch(function(){});
  }
  loadOverrides();

  /* dropdown flutuante */
  var _ovDd=null;
  function closeOvDd(){ if(_ovDd&&_ovDd.parentNode) _ovDd.parentNode.removeChild(_ovDd); _ovDd=null; }
  document.addEventListener("click",function(ev){ if(_ovDd&&!_ovDd.contains(ev.target)) closeOvDd(); });
  document.addEventListener("keydown",function(e){ if(e.key==="Escape") closeOvDd(); });

  function openOvDd(el, field, opts, orderId, currentVal){
    closeOvDd();
    var dd=document.createElement("div"); dd.className="mc-ov-dd";
    var rect=el.getBoundingClientRect();
    var left=rect.left; if(left+180>window.innerWidth) left=window.innerWidth-184;
    var top=rect.bottom+3; if(top+240>window.innerHeight) top=rect.top-3-Math.min(opts.length*30+60,240);
    dd.style.cssText="position:fixed;top:"+top+"px;left:"+left+"px;z-index:9999";
    var h='<div class="mc-ov-dd-head">'+(field==="status"?"Status":"Origem")+'</div>';
    h+=opts.map(function(o){
      return '<div class="mc-ov-item'+(o===currentVal?" is-cur":"")+'" data-val="'+esc(o)+'">'+esc(o)+'</div>';
    }).join("");
    h+='<div class="mc-ov-sep"></div><div class="mc-ov-item mc-ov-reset" data-val="">&#8617; Restaurar automático</div>';
    dd.innerHTML=h;
    dd.addEventListener("click",function(ev){
      ev.stopPropagation();
      var it=ev.target.closest(".mc-ov-item");
      if(!it) return;
      closeOvDd();
      saveOverride(orderId, field, it.getAttribute("data-val"));
    });
    document.body.appendChild(dd);
    _ovDd=dd;
  }

  function saveOverride(orderId, field, val){
    var sid=String(orderId);
    if(!_overrides[sid]) _overrides[sid]={order_id:orderId};
    if(val==="") delete _overrides[sid][field];
    else _overrides[sid][field]=val;
    render();
    call({resource:"order_override_save", order_id:orderId, field:field, value:val}).catch(function(){});
  }

  /* listener delegado: abre dropdown ao clicar em .mc-ov-trigger */
  root.addEventListener("click",function(ev){
    var el=ev.target.closest(".mc-ov-trigger");
    if(!el) return;
    ev.stopPropagation();
    var field=el.dataset.ovField, orderId=el.dataset.ovId, cur=el.dataset.ovCur||"";
    var opts=field==="status"?STATUS_OPTS:ORIGEM_OPTS;
    openOvDd(el, field, opts, orderId, cur);
  });
})();